import {useState} from "react";
import {Button, Field, LoadingSpinner, Typography} from "@matillion/component-library";
import {useUpload} from "./useUpload";
import {errorText} from "../3-perform-scan/scan-operations/error/ErrorText.ts";
import {onChangeStr} from "../../util/ChangeHandler.ts";

export function UploadForm() {
    const [uploadState, upload, error] = useUpload();
    const [label, setLabel] = useState("");
    const [state, setState] = useState<"start" | "active">("start")

    const handleSubmit = () => {
        if (isValid) {
            upload(label.trim())
        }
    };

    const onChange = (e: string) => {
        if(e.length > 3) setState("active")
        setLabel(e)
    }

    const isLabelValid = label.trim().length > 3;
    const showError = (state === "active") && !isLabelValid;
    const isValid = isLabelValid;

    if (uploadState === "uploading") {
        return <>
            <LoadingSpinner />
            <p>Uploading...</p>
        </>
    }

    if (uploadState === "success") {
        return <p>Report uploaded successfully!</p>;
    }

    return (
        <div>
            <h2>Upload</h2>
            <div>
                <Field
                    title="Company Name"
                    description="This is just a label for us to associate with your report"
                    placeholder="ACME Corp"
                    value={label}
                    errorText={showError ? "Please enter a company name longer than 3 characters" : undefined}
                    hasError={showError}
                    required
                    onChange={onChangeStr(onChange)}
                    onBlur={()=>setState("active")}
                />
                <Button 
                    onClick={handleSubmit}
                    disabled={!isValid}
                >
                    Upload Report
                </Button>
                {uploadState === "error" && (
                    <Typography>
                        An error occurred while uploading your report. {errorText(error)}
                    </Typography>
                )}
            </div>
        </div>
    );
}
